namespace RioERP.Invoices {
    export interface FinancialYearForm {
        YearCode: Serenity.StringEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
    }

    export class FinancialYearForm extends Serenity.PrefixedContext {
        static formKey = 'Invoices.FinancialYear';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FinancialYearForm.init)  {
                FinancialYearForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;

                Q.initFormType(FinancialYearForm, [
                    'YearCode', w0,
                    'FromDate', w1,
                    'ToDate', w1
                ]);
            }
        }
    }
}
